
export type FilterByCompletionStatusParamParameter = typeof FilterByCompletionStatusParamParameter[keyof typeof FilterByCompletionStatusParamParameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FilterByCompletionStatusParamParameter = {
  completed: 'completed',
  'in-progress': 'in-progress',
} as const;
